__turbopack_context__.v({
  "figure": "RelatedLinks-module__OhbYEa__figure",
  "icon": "RelatedLinks-module__OhbYEa__icon",
  "iconCell": "RelatedLinks-module__OhbYEa__iconCell",
  "iconCellTall": "RelatedLinks-module__OhbYEa__iconCellTall",
  "item": "RelatedLinks-module__OhbYEa__item",
  "label": "RelatedLinks-module__OhbYEa__label",
  "link": "RelatedLinks-module__OhbYEa__link",
  "list": "RelatedLinks-module__OhbYEa__list",
  "name": "RelatedLinks-module__OhbYEa__name",
  "section": "RelatedLinks-module__OhbYEa__section",
});
